import { trans } from '@/system/utils/translations';

export const languages = [
    {
        id: 'da-DK',
        country: 'da',
        text: trans('settings.language_option_danish'),
    },
    {
        id: 'en-GB',
        country: 'en',
        text: trans('settings.language_option_english'),
    },
    {
        id: 'sv-SE',
        country: 'sv',
        text: trans('settings.language_option_swedish'),
    },
    {
        id: 'nb-NO',
        country: 'no',
        text: trans('settings.language_option_norwegian') + ' (Bokmål)',
    },
    {
        id: 'nn-NO',
        country: 'no',
        text: trans('settings.language_option_norwegian') + ' (Nynorsk)',
    },
    {
        id: 'fi-FI',
        country: 'fi',
        text: trans('settings.language_option_finnish'),
    },
    {
        id: 'nl-NL',
        country: 'nl',
        text: trans('settings.language_option_dutch'),
    },
    {
        id: 'pl-PL',
        country: 'pl',
        text: trans('settings.language_option_polish'),
    },
];

export const defaultLanguageId = 'en-GB';

export const TranscriptionProvider = {
    Aws: 'aws',
    Speechmatics: 'speechmatics',
};

export const SummaryPromptType = {
    FirstVisit: 'first_visit',
    FollowUpVisit: 'follow_up_visit',
};

export const SummaryFeedbackRating = {
    Positive: 'positive',
    Negative: 'negative',
};
